import { render, staticRenderFns } from "./online-static.vue?vue&type=template&id=658f184d&scoped=true&"
import script from "./online-static.vue?vue&type=script&lang=js&"
export * from "./online-static.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f184d",
  null
  
)

export default component.exports